import * as React from "react";
import { AccordionTrigger } from "@/components/ui/accordion";
import { cn } from "@/lib/utils";

interface AccordionTriggerRowProps {
  icon: React.ReactNode;
  title: string;
  summary?: string | null;
  className?: string;
}

/**
 * Reusable trigger row for mobile accordion items.
 * Layout: [Icon 56x56] [Title + Summary]
 * Note: AccordionTrigger already renders the chevron, so we don't add another one.
 */
export function AccordionTriggerRow({
  icon,
  title,
  summary,
  className,
}: AccordionTriggerRowProps) {
  return (
    <AccordionTrigger
      className={cn(
        "px-4 py-3 hover:no-underline data-[state=open]:bg-background",
        "transition-colors duration-200",
        className
      )}
    >
      <div className="flex items-center gap-4 text-left w-full">
        {/* Icon container */}
        <div
          className={cn(
            "h-14 w-14 shrink-0 flex items-center justify-center",
            "rounded-lg"
          )}
        >
          {icon}
        </div>

        {/* Title and summary */}
        <div className="flex-1 min-w-0">
          <div className="text-[15px] font-semibold leading-tight text-foreground">
            {title}
          </div>
          <div className="mt-1 text-[13px] font-normal text-muted-foreground truncate">
            {summary || "—"}
          </div>
        </div>
      </div>
    </AccordionTrigger>
  );
}
